// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.policy-details {
  max-height: 50vh;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/authentication/registration/policy-modal/policy-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,cAAA;AACF","sourcesContent":[".policy-details {\n  max-height: 50vh;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
